<template>
  <div
    class="registro-content"
    :class="[
      { 'padding-sem-checkbox': paddingSemCheckBox },
      { desabilitado: desabilitado },
      { 'sem-padding-bottom': semPaddingBottom },
      colorido ? `registro-${classe}` : ''
    ]"
  >
    <slot />
  </div>
</template>

<script>
import stringFormatMixin from "@/mixins/stringFormatMixin";

export default {
  name: "Registro",

  mixins: [stringFormatMixin],

  props: {
    paddingSemCheckBox: Boolean,
    semPaddingBottom: Boolean,
    desabilitado: Boolean,
    colorido: Boolean,
    classe: String
  }
};
</script>

<style lang="scss" scoped>
.registro-content {
  border-radius: 2px;
  border: 1px solid #cccccc;
  padding: 0.5rem 9px;
  flex: 1;
  background: var(--cinza0);
  // box-shadow: 2px 2px 6px #00000010;
}
.padding-sem-checkbox {
  margin-left: 21px;
}
.sem-padding-bottom {
  padding-bottom: 0;
}
.desabilitado {
  opacity: 0.4;
}
.registro-class_importacao {
  border: 1px solid var(--importacao);
}
.registro-pis_cofins,
.registro-cide_combustivel {
  border: 1px solid var(--pis-cofins);
}
.registro-icms_interno,
.registro-icms_st,
.registro-carga_liquida,
.registro-difal,
.registro-antecipacao {
  border: 1px solid var(--icms);
}
.registro-ipi {
  border: 1px solid var(--ipi);
}

@media only print {
  .padding-sem-checkbox {
    margin-left: 0px;
  }
  .registro-content {
    page-break-inside: avoid;
    // margin-top: 5px;
  }
  .registro-class_importacao,
  .registro-pis_cofins,
  .registro-cide_combustivel,
  .registro-icms_interno,
  .registro-icms_st,
  .registro-carga_liquida,
  .registro-difal,
  .registro-antecipacao,
  .registro-ipi {
    border: 1px solid #cccccc;
  }
}
</style>
